<template>
    <div class="footPage">
        <div>
            <div class="footTop">
                <div class="topmenu" @click="afters">售后规则</div>
                <div class="topmenu">|</div>
                <div class="topmenu" @click="termServe">服务条款</div>
                <div class="topmenu">|</div>
                <div class="topmenu" @click="abouts">关于我们</div>
            </div>
        </div>
        <div class="footBot">
            <div class="botmenu">版权所有：xxxxx责任有限公司</div>
            <div class="botmenu">备案号：鲁IPC备15445223245-1号</div>
        </div>
        <div class="copyright">
            Copyright @2021-2025 www.baidu.com,All rights reserved
        </div>
    </div>
</template>
<script setup>
import { useRouter } from 'vue-router'
const router = useRouter()
const afters=()=> {
    router.push('/afterSales')
}

const termServe=()=> {
    router.push('/termService')
}

const abouts=()=> {
    router.push('/aboutUs')
}
</script>
<style lang="scss" scoped>
.footPage {
    background-color: #434343;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;

    .footTop {
        display: flex;
        align-items: center;
        justify-content: space-around;

        .topmenu {
            padding: 20px 30px;
            cursor: pointer;
        }
    }

    .footBot {
        display: flex;
        align-items: center;

        .botmenu {
            padding: 20px 30px;

        }
    }

    .copyright {
        padding: 20px 30px;

    }
}
</style>